/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-no-constructed-context-values */
/* eslint-disable import/extensions */
import Image from 'next/image';
import { usePathname } from 'next/navigation';
import { useRouter } from 'next/router';
import React, { useContext, useEffect, useState, } from 'react';
import { Nav, Navbar, Button, Col, } from 'react-bootstrap';
import { FaCar } from 'react-icons/fa6';
import { MessagesContext } from '@/pages/_app';
import Messages from '@/components/messages';
import Toasts from '@/components/toasts';
import DropdownProfile from '@/components/menus/dropdown-profile';
import { layout, messages, store, } from '@/helpers/index';
import { auth } from '@/services/auth';
import Footer from '@/components/footer';
import Loading from '@/components/loading';
import { constant } from '@/helpers/constant';
import SignModal from '../modals/sign';

export default function LayoutComponent({ enableMessages, children }) {
  const pathname = usePathname();
  const router = useRouter();
  const { stateMessages, dispatchMessages } = useContext(MessagesContext);
  const [user, setUser] = useState(auth.store.logged.get());
  const [showChild, setShowChild] = useState(false);
  const [loginShow, setLoginShow] = useState(false);

  const handleReportRescue = () => {
    router.push('/acesse-seu-relatorio');
  };

  const handleLogin = () => {
    if (window.location.pathname === constant.redirect.login) { return; }
    if (!window.location.pathname.includes('/seminovos')) {
      router.push(constant.redirect.login);
      return;
    }
    messages.clear();
    setLoginShow(true);
  };

  useEffect(() => {
    setShowChild(true);
    store.menu.crm.remove();
  }, []);

  if (!showChild || typeof window === 'undefined') { return null; }

  return (
    <>
      <header className="site">
        <Navbar id="navbar" bg="default" expand="md" className="not-printable px-3 px-lg-4">
          <Navbar.Brand href="/seminovos" className="not-printable" onClick={layout.menu.close}>
            <Image src="/assets/themes/default/images/logo-classifieds.png" width="247" height="55" border="0" alt="Logomarca da AboutCar - Seminovos" quality={75} />
          </Navbar.Brand>
          {!user && (
            <div className="d-block d-sm-none not-printable">
              {pathname !== constant.redirect.login && (
                <Button variant="success" onClick={handleLogin} className="btn-gradient-success rounded-pill px-3 py-1 fw-bold shadow-sm">
                  Entrar
                </Button>
              )}
            </div>
          )}
          <Navbar.Toggle aria-controls="basic-navbar-nav" className="not-printable border-0 shadow-none pe-0" />
          {user && (
            <Col xs={12} className="mobile-cart not-printable">
              <div className="text-center">
                <DropdownProfile />
              </div>
            </Col>
          )}
          <Navbar.Collapse id="basic-navbar-nav" className="not-printable">
            <Nav className="me-auto not-printable gap-1">
              <Nav.Link href="/" onClick={layout.menu.close} className="rounded">Site</Nav.Link>
              <Nav.Link href="/seminovos" onClick={layout.menu.close} active={pathname.includes('/seminovos') && pathname !== '/seminovos/meus-favoritos'} className="nav-link-seminovos">
                <FaCar className="me-1" />
                Seminovos
                <span className="seminovos-badge ms-1">NOVO</span>
              </Nav.Link>
              {user && <Nav.Link href="/seminovos/meus-favoritos" onClick={layout.menu.close} active={pathname === '/seminovos/meus-favoritos'} className="rounded">Meus Favoritos</Nav.Link>}
              <Nav.Link href="/parceria" onClick={layout.menu.close} active={pathname === '/parceria'} className="rounded">Parceria</Nav.Link>
              {/* <Nav.Link href="https://blog.aboutcar.com.br" target="_blank" rel="noreferrer" onClick={layout.menu.close} className="rounded">Blog</Nav.Link> */}
              <Nav.Link href="/contato" onClick={layout.menu.close} active={pathname === '/contato'} className="rounded">Contato</Nav.Link>
              {/* <Nav.Link href="/acesse-seu-relatorio" onClick={layout.menu.close} active={pathname === '/acesse-seu-relatorio'} className={user ? 'rounded' : 'rounded d-sm-none'}>Acesse seu Relatório</Nav.Link> */}
            </Nav>
            {user ? <div className="desktop-cart not-printable"><DropdownProfile /></div> : (
              <div className="desktop-cart not-printable d-flex align-items-center gap-2">
                {pathname !== constant.redirect.login && (
                  <Button variant="success" onClick={handleLogin} className="btn-gradient-success rounded-pill px-4 py-2 fw-bold border-0 shadow-sm">
                    Entrar
                  </Button>
                )}
                {pathname !== constant.redirect.login && (
                  <Button variant="primary" onClick={handleReportRescue} className="btn-gradient-primary rounded-pill px-3 py-2 fw-semibold border-0 shadow-sm d-none d-lg-inline-block">
                    Acesse seu Relatório
                  </Button>
                )}
              </div>
            )}
          </Navbar.Collapse>
        </Navbar>
      </header>
      <main role="main" id="main">
        {enableMessages && <Messages items={stateMessages.messages} clear={messages.clear} />}
        {children}
        <Footer />
      </main>
      <Loading />
      {loginShow && <SignModal path="/seminovos" setUser={setUser} setShow={setLoginShow} />}
      <Toasts items={stateMessages.messages} clear={messages.clear} />
    </>
  );
}
